import EvaluationService from 'services/data-handler-services/evaluation-service';
import utils from 'lib/utils';
import Backbone from 'backbone';

const PollService = function () {
  this.renderPoll = function (blockView) {
    blockView.poll.set('response_set', EvaluationService.getResponseSet(blockView.model.get('slug')));
    const options = {
      parse: true,
      headers: {
        Authorization: `Bearer ${blockView.poll.get('response_set').token}`,
      },
    };
    blockView.poll.fetch(options).done(() => {
      blockView.model.set('translate', false);
      blockView.model.set('text', blockView.poll.get('text'));
      blockView.model.set('id', blockView.poll.get('id'));
      blockView.model.set('answers', blockView.poll.get('answers'));
      blockView.render();
    });
  };

  this.getUrl = function (model) {
    return `${model.get('response_set').endpoint}/response_sets/${
      model.get('response_set').id
    }.json?include=evaluation,sections.questions.answers`;
  };

  this.parse = function (model, response) {
    if (!(response && response.data)) {
      return;
    }
    const pollData = utils.sanifyJsonApiObject(response.data, response.included);
    utils.setSectionsData(pollData);
    //SDK polls expect only one section/question for now
    const sectionIndex = model.get('sectionIndex') || 0;
    const questionIndex = model.get('questionIndex') || 0;

    //return question
    return pollData.sections[sectionIndex].questions[questionIndex];
  };

  this.save = function (model, options) {
    options = options || {};
    options.headers = {
      Authorization: `Bearer ${model.get('response_set').token}`,
    };
    const answers = Array.isArray(model.get('response_id'))
      ? [
          {
            question_id: model.get('id'),
            value: model.get('response_id'),
            response_type: 'multiple_selection',
          },
        ]
      : [
          {
            question_id: model.get('id'),
            value: model.get('response_id'),
            user_supplied_text: model.get('user_supplied_text'),
            response_type: 'single_selection',
          },
        ];

    options.attrs = {
      data: {
        id: model.get('response_set').id,
        type: 'response_sets',
        attributes: {
          answers,
        },
      },
    };
    return new Promise((resolve, reject) => {
      return Backbone.Model.prototype.save.call(model, options.attrs, options).then(() => {
        const headers = new Headers();
        headers.set('Authorization', `Bearer ${model.get('response_set').token}`);
        return fetch(
          `${model.get('response_set').endpoint}/response_sets/${model.get('response_set').id}/poll_results`,
          { headers }
        )
          .then(resp => resp.json())
          .then(response => {
            const sectionIndex = model.get('sectionIndex') || 0;
            const questionIndex = model.get('questionIndex') || 0;
            const answers = {
              totals: response.data.attributes.results.sections[sectionIndex].questions[questionIndex].answers,
            };
            resolve(answers);
          });
      });
    });
  };
};

export default new PollService();
